import dayjs from 'dayjs';
import esLocale from 'dayjs/locale/es';

dayjs.locale({
  ...esLocale
});

export const formatsEnum = {
  FORMAT_DATE_1: 'DD-MM-YYYY',
  FORMAT_DATE_2: 'YYYY-MM-DD',
  FORMAT_DATE_3: 'YYYY/MM/DD',
  FORMAT_DATE_4: 'DD/MM/YYYY',
  FORMAT_DATE_5: 'D/M/YYYY',
  FORMAT_DATE_6: 'DD/MM/YYYY - HH:mm'
};

export const MONTHS = [
  'ENERO',
  'FEBRERO',
  'MARZO',
  'ABRIL',
  'MAYO',
  'JUNIO',
  'JULIO',
  'AGOSTO',
  'SEPTIEMBRE',
  'OCTUBRE',
  'NOVIEMBRE',
  'DICIEMBRE'
];

export const convertMonthToSpanish = (monthString) => {
  if (!monthString) return monthString;

  const monthTranslations = {
    JANUARY: 'ENERO',
    FEBRUARY: 'FEBRERO',
    MARCH: 'MARZO',
    APRIL: 'ABRIL',
    MAY: 'MAYO',
    JUNE: 'JUNIO',
    JULY: 'JULIO',
    AUGUST: 'AGOSTO',
    SEPTEMBER: 'SEPTIEMBRE',
    OCTOBER: 'OCTUBRE',
    NOVEMBER: 'NOVIEMBRE',
    DECEMBER: 'DICIEMBRE'
  };

  let result = monthString;

  Object.entries(monthTranslations).forEach(([english, spanish]) => {
    result = result.replace(english, spanish);
  });

  return result;
};

export const formatDate = ({ value }) => {
  const newDate = value?.split('T')[0].split('-').reverse().join('/');

  return newDate;
};

export const formDateHour = (value) => {
  const newValue = value.split('T');
  const newDate = newValue[0].split('-').reverse().join('/');
  const valueAfter = newValue[1];
  const newHour = valueAfter.split(':').slice(0, 2).join(':');

  return {
    newDate,
    newHour
  };
};
export const formatProviders = (providers, businessUnit) =>
  providers.map(({ numeroContrato }) => ({
    nroContrato: numeroContrato,
    idUnidadNegocio: businessUnit.id
  }));

export const formatProvidersOyM = (providers, businessUnit) =>
  providers.map(({ numeroContrato }) => ({
    nroContrato: numeroContrato,
    idOperacion: businessUnit.id
  }));

export const formatApproversToForm = (approvers) =>
  approvers.map((approver) => ({
    ...approver,
    label: approver.nombre,
    value: approver.id
  }));

export const formatApproversToAdd = (approvers) =>
  approvers.map((approver) => ({
    idSolicitudServicioAprobadorDestinatario: approver.idSolicitudServicioAprobador || 0,
    id: approver?.idOriginal,
    value: `${approver.id}-${approver.esGrupo ? 'grupo' : 'persona'}`,
    nombre: approver.nombre,
    esGrupo: approver.esGrupo,
    idProveedor: approver.idProveedor
  }));

export const formatApproversToDelete = (approvers) =>
  approvers.map(({ idSolicitudServicioAprobador, idOriginal, ...rest }) => ({
    ...rest,
    id: idOriginal,
    idSolicitudServicioAprobadorDestinatario: idSolicitudServicioAprobador
  }));

export const formatAmountDate = (value) => value?.split('T')[0].split('-').reverse().join('/');
export const reverseFormatAmountDate = (value) => value?.split('/').reverse().join('-');

export const getEndingDate = (dat, addDay) => {
  const dayAdded = dayjs(dat)
    .add(addDay - 1, 'day')
    .format(formatsEnum.FORMAT_DATE_2);

  return dayAdded;
};

export const formatAmountDateBack = (dat) => dat.split('T')[0];

export const formatDateToSpanish = (fullDate) => {
  if (!fullDate) {
    return {};
  }
  const date = new Date(fullDate.split('T')[0]);
  const year = date.getFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDay();
  const dayNumber = date.getUTCDate();

  const newDate = {
    year
  };
  const newDay = {
    number: dayNumber
  };

  switch (day) {
    case 0:
      newDay.text = 'domingo';
      newDay.abbr = 'dom';
      break;
    case 1:
      newDay.text = 'lunes';
      newDay.abbr = 'lun';
      break;
    case 2:
      newDay.text = 'martes';
      newDay.abbr = 'mar';
      break;
    case 3:
      newDay.text = 'miércoles';
      newDay.abbr = 'mie';
      break;
    case 4:
      newDay.text = 'jueves';
      newDay.abbr = 'jue';
      break;
    case 5:
      newDay.text = 'viernes';
      newDay.abbr = 'vie';
      break;
    case 6:
      newDay.text = 'sábado';
      newDay.abbr = 'sáb';
      break;
    default:
      newDay.text = null;
  }
  newDate.day = newDay;

  switch (month) {
    case 0:
      newDate.month = 'enero';
      break;
    case 1:
      newDate.month = 'febrero';
      break;
    case 2:
      newDate.month = 'marzo';
      break;
    case 3:
      newDate.month = 'abril';
      break;
    case 4:
      newDate.month = 'mayo';
      break;
    case 5:
      newDate.month = 'junio';
      break;
    case 6:
      newDate.month = 'julio';
      break;
    case 7:
      newDate.month = 'agosto';
      break;
    case 8:
      newDate.month = 'septiembre';
      break;
    case 9:
      newDate.month = 'octubre';
      break;
    case 10:
      newDate.month = 'noviembre';
      break;
    case 11:
      newDate.month = 'diciembre';
      break;
    default:
      newDate.month = null;
  }

  return newDate;
};

export const classNames = (...args) => args.filter((x) => !!x).join(' ');

export const capitalize = (string) => {
  if (!string) return '';
  const arr = string?.split(' ').filter((x) => !!x);
  const capitalizedArr = arr.map((x) => x.charAt(0).toUpperCase() + x.slice(1));

  return capitalizedArr.join(' ');
};

export const formatDayName = (value) => `${dayjs(value).format('dddd')}`;
export const formatDay = (value) => `${dayjs(value).format('DD')}`;
export const formatMonthName = (value) => `${dayjs(value).format('MMMM')}`;
export const formatYear = (value) => `${dayjs(value).format('YYYY')}`;

export const formatFullDate = (value, format = formatsEnum.FORMAT_DATE_4) =>
  dayjs(value).format(format);

// Month Matrix
export const getMonth = (monthDay = dayjs().month(), yearDay = dayjs().year()) => {
  const month = Math.floor(monthDay);
  const firstDayOfTheMonth = dayjs(new Date(yearDay, month, 1)).day();
  let currentMonthCount = 0 - firstDayOfTheMonth;

  // Build a matrix of 6 (rows) x 7 (columns)
  // Where columns represent the 7 days of the week
  // Where rows represent the number of weeks per month

  const daysMatrix = new Array(6).fill([]).map(() =>
    new Array(7).fill(null).map(() => {
      currentMonthCount += 1;

      return dayjs(new Date(yearDay, month, currentMonthCount));
    })
  );

  return daysMatrix;
};

export const formatMonthYear = (value) => `${dayjs(value).format('MMM/YYYY')}`;

// Concatenates the names of the provided files
export const formatFileNames = (files) =>
  new Intl.ListFormat('es', {
    type: 'conjunction'
  }).format(files.map((file) => file.name));

export const getFirstDayOfMonth = (monthParam, yearParam) => {
  const date = new Date(parseInt(yearParam, 10), monthParam, 1);

  return date?.toISOString().split('T')[0];
};

export const getLastDateOfMonth = (monthParam, yearParam) => {
  const date = new Date(parseInt(yearParam, 10), monthParam + 1, 0);

  return date?.toISOString().split('T')[0];
};
// Format a list of approvers as an array of arrays
// containing each combination of approvers with the same name
// Used in the MSDS approvers tab
export const groupApprovers = (approvers) => {
  const pooledApprovers = [];

  approvers.forEach((approver) => {
    const approverIndex = pooledApprovers.findIndex((apprArr) =>
      apprArr.some((appr) => appr?.nombre === approver?.nombre)
    );

    if (approverIndex >= 0) {
      pooledApprovers[approverIndex].push(approver);
    } else {
      pooledApprovers.push([approver]);
    }
  });

  return pooledApprovers;
};

export const formatCreateASDS = (values) => {
  const ubicacion = {
    tipoUbicacionEnum: values.ubication.ubicationType?.id,
    ubicacionNombre: values.ubication.ubication?.nombre,
    idUnidadNegocio: values.ubication.uunn?.id,
    unidadNegocioNombre: values.ubication.uunn?.nombre,
    idEvento: values.ubication.event?.id || values.imputationObject.wells[0].event?.id,
    eventoNombre: values.ubication.event?.nombre || values.imputationObject.wells[0].event?.label,
    eventoSigla: values.ubication.event?.sigla || values.imputationObject.wells[0].event?.sigla,
    pozos: values.imputationObject.wells.map((well) => ({
      idObjetoImputacion: well.imputationObject?.value,
      idPozo: well.well.id || well.well?.value,
      idEquipo:
        well.team.id ||
        well.team?.value ||
        values.ubication?.team?.id ||
        values.ubication?.team?.value,
      tipoImputacionEnum: well.imputationType.value,
      idEventoPozo: well.event.eventoPozoId
    }))
  };
  const servicio = {
    idServicio: values.service.service?.id,
    servicioNombre: values.service.service?.nombre,
    fechaProbableRealizacion: values.service.probDate,
    fechaRespuesta: values.service.needDate,
    descripcion: values.service.description
  };
  const proveedores = [
    {
      idProveedor: values.provider.providers[0]?.provider?.id,
      idUnidadNegocio: values.provider.moreBusinessUnit
        ? values.provider.businessUnit?.id
        : values.ubication.uunn?.id,
      idContrato: values.provider.providers[0]?.contract?.id,
      requiereAceptacion: values.provider.providers[0]?.contract?.requiereAceptacion,
      requiereAdjuntarArchivo: values.provider.providers[0]?.contract?.requiereAdjuntarArchivo,
      numeroContrato: values.provider.providers[0]?.contract?.nombre,
      tipoNotificacionEnum: values.provider.providers[0]?.notificate?.id
    }
  ];

  return {
    ubicacion,
    servicio,
    proveedores
  };
};

export const getRandomKey = () => new Date().getTime() / Math.random();

// The function below was made to work with Objects and Arrays
export const formatFilterToComboOption = (filter) => {
  if (!filter) return null;
  if (Array.isArray(filter)) {
    return filter.map((e) => ({
      value: e.id,
      label: e.nombre,
      ...e
    }));
  }
  if (typeof filter === 'object') {
    return {
      value: filter.id,
      label: filter.nombre,
      ...filter
    };
  }

  return null;
};

export const validateDecimalInput = (value, maxDecimals) => {
  const regex = new RegExp(`^\\d+(\\.\\d{0,${maxDecimals}})?$`);

  return regex.test(value) || value === '';
};

export const validateOnlyDecimalInput = (value, maxDecimals) => {
  const regex = new RegExp(`^\\d+(\\.\\d{0,${maxDecimals}})?$`);

  return regex.test(value);
};

export const validateZerosInput = (value, maxDecimals) => {
  // Regex to allow only valid numbers (without unnecessary leading zeros)
  const regex = new RegExp(`^(0|[1-9]\\d*)(\\.\\d{0,${maxDecimals}})?$`);

  return regex.test(value) || value === '';
};

export const validateDigitsInput = (value, maxDigits) => {
  const regex = new RegExp(`^\\d{0,${maxDigits}}$`);

  return regex.test(value);
};
export const formatDateWithHour = (fecha) => `${fecha.split('-').join('-')}T00:00:00`;
